export const GET_INVOICE_BY_ID = 'congero/invoices/get_invoice_by_id';
export const GET_INVOICE_BY_ID_FAILED = 'congero/invoices/get_invoice_by_id_failed';
export const GET_INVOICE_TEMPLATE = 'GET_INVOICE_TEMPLATE';
export const GET_INVOICE_TEMPLATE_SUCCESS = 'GET_INVOICE_TEMPLATE_SUCCESS';
export const GET_NOTE_BY_ID = 'congero/invoices/GET_NOTE_BY_ID';
